// extracted by mini-css-extract-plugin
export default {"container":"count_container__U4d0F","text":"count_text__TO7pA"};